"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_use_1 = require("react-use");
const uuid_1 = require("uuid");
const styled_components_1 = require("styled-components");
const deep_equal_1 = __importDefault(require("deep-equal"));
const mui_1 = require("tss-react/mui");
const AttachMoneyRounded_1 = __importDefault(require("@mui/icons-material/AttachMoneyRounded"));
const styles_1 = require("@mui/material/styles");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const categories_svg_1 = __importDefault(require("assets/nav-menu/categories.svg"));
const settings_svg_1 = __importDefault(require("assets/nav-menu/settings.svg"));
const tags_svg_1 = __importDefault(require("assets/nav-menu/tags.svg"));
const budgets_svg_1 = __importDefault(require("assets/nav-menu/budgets.svg"));
const under_construction_png_1 = __importDefault(require("assets/under-construction.png"));
const QList_1 = __importDefault(require("components/QList"));
const QListDetails_1 = __importDefault(require("components/QList/QListDetails"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const styles_2 = __importStar(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_2.default);
const icons = {
    categories: <img alt={'categories'} src={categories_svg_1.default}/>,
    tags: <img alt={'categories'} src={tags_svg_1.default}/>,
    settings: <img alt={'categories'} src={settings_svg_1.default}/>,
    budgets: <img alt={'categories'} src={budgets_svg_1.default}/>,
    finances: <AttachMoneyRounded_1.default />,
};
const SettingsItems = (props) => {
    const { classes, theme } = useStyles();
    const { dataDictionary, title, settingType, titleIconName = 'settings', underConstruction = false } = props, other = __rest(props, ["dataDictionary", "title", "settingType", "titleIconName", "underConstruction"]);
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const [data, setData] = (0, react_1.useState)(props.mkItemArray(props.items));
    const prevItems = (0, react_use_1.usePrevious)(props.items);
    const findIdInData = (id, passedData) => {
        let retVal = null;
        passedData.some((x) => {
            if (x.id === id) {
                retVal = x;
                return true;
            }
            if (x.children) {
                retVal = findIdInData(id, x.children);
                return (retVal !== null);
            }
            return false;
        });
        return retVal;
    };
    const executeDeleteItems = (items) => {
        if (props.deleteItems) {
            const itemsToDelete = [];
            items.forEach((id) => {
                const item = findIdInData(id, data);
                // @ts-expect-error TS(2345) - FIXME: Argument of type 'any' is not assignable to parameter of type 'never'
                if (item)
                    itemsToDelete.push(props.mkImmutableItem(item));
            });
            return props.deleteItems(itemsToDelete);
        }
        items.forEach((id) => {
            const item = findIdInData(id, data);
            if (item) {
                props.deleteItem(props.mkImmutableItem(item));
            }
        });
        return true;
    };
    const compareFields = (rec, item, fldRecord) => {
        if (rec.values && rec.values[fldRecord.id]) {
            return (0, deep_equal_1.default)(rec.values[fldRecord.id], item.values[fldRecord.id]);
        }
        return (rec[fldRecord.id] === item[fldRecord.id]);
    };
    const checkForDuplicates = (passedData, passedDataDictionary, item) => {
        const uniqueFields = dataDictionary.filter((x) => x.unique || x.uniqueWith);
        let dupeField = null;
        if (uniqueFields) {
            // check every record that was provided looking for a duplicate
            passedData.forEach((rec) => {
                // check each field that was marked unique
                let oneDupeField = null;
                uniqueFields.forEach((fld) => {
                    if (rec[fld.id] === item[fld.id] && rec.id !== item.id) {
                        oneDupeField = fld.id;
                    }
                    // if uniqueWith is being used, then it must also match the fields in the uniqueWith array
                    // run through the dups found
                    if (oneDupeField && fld.uniqueWith) {
                        // start by assuming they will all match
                        let withFieldsMatched = true;
                        // check each 'with' field from the data dictionary
                        fld.uniqueWith.forEach((fldId) => {
                            const withField = dataDictionary.find((f) => f.id === fldId);
                            if (!compareFields(rec, item, withField)) {
                                // if one does not match, this overall is not a match
                                withFieldsMatched = false;
                            }
                        });
                        if (!withFieldsMatched) {
                            oneDupeField = null;
                        }
                    }
                });
                dupeField = oneDupeField || dupeField;
                // recursion for children
                if (rec.children && !dupeField) {
                    dupeField = dupeField || checkForDuplicates(rec.children, passedDataDictionary, item);
                }
            });
        }
        return dupeField;
    };
    const onDelete = (items) => {
        if (items.length === 1) {
            return executeDeleteItems(items);
        }
        const es = items.length > 1 ? 's' : '';
        dialogAlert(`Delete ${items.length} Item${es}?`, `You are about to delete ${items.length} item${es}.  Are you sure?`, (ret) => {
            if (ret.btnPressed === 'Yes') {
                return executeDeleteItems(items);
            }
            return true;
        }, ['Cancel', 'Yes']);
        return true;
    };
    // item returned with an id = 0 is a new item
    const onSave = (newBudgetItem) => {
        const dupField = checkForDuplicates(data, dataDictionary, newBudgetItem);
        if (dupField) {
            dialogAlert('That item already exists!', `Sorry, but that item already exists, you need to use a unique ${dupField}.`, () => { }, ['Got It']);
        }
        else if (Number(newBudgetItem.id) === 0) {
            const newId = (0, uuid_1.v4)().toUpperCase();
            props.createItem(props.mkImmutableItem(Object.assign(Object.assign({}, newBudgetItem), { id: null, clientId: newId })));
        }
        else {
            props.updateItem(props.mkImmutableItem(Object.assign({}, newBudgetItem)));
        }
    };
    (0, react_1.useEffect)(() => {
        props.getItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if (props.items !== prevItems) {
            setData(props.mkItemArray(props.items));
        }
    }, [props, prevItems]);
    return (<styles_1.StyledEngineProvider injectFirst>
      <styled_components_1.ThemeProvider theme={theme}>
        <div className={classes.root}>
          <div>
            <Grid_1.default container>
              <Grid_1.default item xs>
                {underConstruction &&
            <>
                    <styles_2.SectionTitle>
                      <Typography_1.default variant="h3">{title}</Typography_1.default>
                    </styles_2.SectionTitle>
                    <div className={classes.underConstructionContainer}>
                      <br />
                      <br />
                      <img alt="page is under construction" src={under_construction_png_1.default} className={classes.imgUnderConstruction}/>
                    </div>
                  </>}

                {!underConstruction &&
            <>
                    <div className={classes.sectionTitle}>
                      <div className={classes.navMenuItem}>
                        {icons[titleIconName]}
                      </div>
                      <Typography_1.default variant="h5" className={classes.titleText}>
                        {title}
                      </Typography_1.default>
                    </div>
                    <QList_1.default {...other} data={data.toJS()} dataDictionary={dataDictionary.toJS()} defaultSort={dataDictionary.first().id} detailsComponent={QListDetails_1.default} onSave={onSave} onDelete={onDelete} listItemType={settingType}/>
                  </>}
              </Grid_1.default>
            </Grid_1.default>
          </div>
        </div>
      </styled_components_1.ThemeProvider>
    </styles_1.StyledEngineProvider>);
};
exports.default = (0, react_1.memo)(SettingsItems);
